<style lang="scss">
  @use "../../../../../assets/css/global.scss" as *;
  @use "../../../../../assets/css/_colors.scss" as *;
  video {
    width: 100%;
    border-radius: 8px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
    max-height: 320px;
    height: auto;
  }
  .video-container {
    max-width: max-content;

    @media (max-width: 1600px) {
      width: 75%;
    }

    &.increase-min-width {
      min-width: 50%;
    }
  }

  .video-content {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    max-width: 420px;

    @media (max-width: 1600px) {
      width: 75%;
      max-width: 100%;
    }

    .video-task-description {
      font-size: 0.9rem;
      color: $text-gray;
    }
    .task-actions {
      display: grid;
      grid-template-columns: auto auto;
      gap: 1rem;
      justify-content: start;
    }

    .video-footer {
      margin-top: 0.5rem;
      display: inline-block;
      width: 200%;
    }

    .video-footer a {
      display: inline;
    }
  }

  .play-pause {
    margin-right: 0.2rem;
  }
</style>

<script>
  import ActionButton from "../Components/ActionButton.svelte";

  export let task;

  import {
    createVideoTracker,
    interactiveTasks,
    isVideoPlaying,
  } from "../stores";

  let videoEl;
  let videoTracker = {};

  $: if (videoEl && task && videoTracker.taskId !== task.taskId) {
    if (videoTracker.reset) videoTracker.reset();
    videoTracker = createVideoTracker({
      taskId: task.taskId,
      taskStatus: task.status,
      videoEl,
    });
  }

  $: expanded = $interactiveTasks.selectedTaskId === task.taskId;

  $: src = [
    window.location.host === "localhost" ? "https://sourcewhale.app" : "",
    task.cta.primary.attributes?.src ||
      "/training-videos/Quick Start Guide/Downloading the extension.mp4",
  ].join("");
  const hideTaskGroups = document
    .getElementById("training")
    ?.classList.contains("hideTaskGroups");

  const togglePlayPause = () =>
    videoEl.paused ? videoEl.play() : videoEl.pause();

  const handleSecondaryClick = () => videoEl && videoEl.pause();

  const centerVideoEl = () => {
    if (!document.fullscreenElement && videoEl)
      setTimeout(() => {
        videoEl
          .closest(".video-task-layout")
          .scrollIntoView({ block: "center" });
      }, 100);
  };

  const footerClick = () => {
    if (!task.videoFooter) return;
    handleSecondaryClick();
  };

  $: if (videoEl && !expanded) videoEl.pause();
</script>

<div class="video-container {hideTaskGroups ? 'increase-min-width' : ''}">
  <!-- svelte-ignore a11y-media-has-caption -->
  <video bind:this={videoEl} {src} controls on:fullscreenchange={centerVideoEl}>
  </video>
</div>

<div class="video-content">
  <p class="video-task-description">{task.description}</p>
  <div class="task-actions">
    <ActionButton
      class="primary"
      onclick={togglePlayPause}
      {...task.cta.primary.attributes}
    >
      {#if $isVideoPlaying}
        <i class="fa-solid fa-pause play-pause"></i> Pause Video
      {:else}
        <i class="fa-solid fa-play play-pause"></i> Play Video
      {/if}
    </ActionButton>
    <ActionButton
      class="secondary"
      onclick={handleSecondaryClick}
      {...task.cta.secondary.attributes}
    >
      {task.cta.secondary.text}
    </ActionButton>
  </div>
  {#if task.videoFooter}
    <div class="video-footer">
      Try it for yourself. Go to <a
        on:click={footerClick}
        href={task.videoFooter.href}
        target="_blank">{task.videoFooter.text}.</a
      >
    </div>
  {/if}
</div>
